module.exports = __webpack_public_path__ + "img/icon-1.fcd4fbf0.png";